export default __webpack_public_path__ + "static/media/IconDesc_StreetLight.256.d533a8cc.png";